import { useMemo } from 'react'

import { Box } from '@mui/material'

import { IGridColumn } from 'components/common'

const useGetExportCustomersColumns = () => {
  const columns: IGridColumn[] = useMemo(
    () => [
      {
        field: 'exportStatus',
        headerName: 'Export Status',
        minWidth: 150,
        cellClassName: (params: any) => {
          const status = params.row.exportStatus
          if (status === 'Not Synced') return 'cell-not-synced'
          if (status === 'Synced') return 'cell-synced'
          if (status === 'Failed') return 'cell-failed'
          return ''
        },
      },
      {
        field: 'id',
        headerName: 'Customer ID',
        minWidth: 120,
        sortPath: ['customer', 'id'],
        valueGetter: (params: any) => params.row.customer?.id || '--',
      },
      {
        field: 'hubSpotSyncDate',
        headerName: 'Timestamp of export attempt',
        minWidth: 250,
        sortPath: ['customer', 'hubSpotSyncDate'],
        valueGetter: (params: any) => params.row.customer?.hubSpotSyncDate,
        valueFormatter: (params: any) =>
          params.value ? new Date(params.value).toLocaleString('en-GB') : '--',
      },
      {
        field: 'hubSpotObjectId',
        headerName: 'HS Record ID',
        minWidth: 150,
        sortPath: ['customer', 'hubSpotObjectId'],
        valueGetter: (params: any) => params.row.customer?.hubSpotObjectId || '--',
      },
      {
        field: 'name',
        renderHeader: () => (
          <Box sx={{ whiteSpace: 'normal', lineHeight: 'normal' }}>
            <strong>Trading Name</strong>
            <br />
            (Name)
          </Box>
        ),
        minWidth: 250,
        sortPath: ['customer', 'name'],
        valueGetter: (params: any) => params.row.customer?.name || '--',
      },
      {
        field: 'telephoneNumber',
        renderHeader: () => (
          <Box sx={{ whiteSpace: 'normal', lineHeight: 'normal' }}>
            <strong>Telephone Number</strong>
            <br />
            (Phone)
          </Box>
        ),
        minWidth: 200,
        sortPath: ['customer', 'telephoneNumber'],
        valueGetter: (params: any) => params.row.customer?.telephoneNumber || '--',
      },
      {
        field: 'city',
        renderHeader: () => (
          <Box sx={{ whiteSpace: 'normal', lineHeight: 'normal' }}>
            <strong>City</strong>
            <br />
            (City & Location)
          </Box>
        ),
        minWidth: 200,
        sortPath: ['customer', 'city'],
        valueGetter: (params: any) => params.row.customer?.city || '--',
      },
      {
        field: 'postcode',
        renderHeader: () => (
          <Box sx={{ whiteSpace: 'normal', lineHeight: 'normal' }}>
            <strong>Postcode</strong>
            <br />
            (Zip)
          </Box>
        ),
        minWidth: 150,
        sortPath: ['customer', 'postcode'],
        valueGetter: (params: any) => params.row.customer?.postcode || '--',
      },
      {
        field: 'vatIdNumber',
        headerName: 'VAT Number',
        minWidth: 200,
        sortPath: ['customer', 'vatIdNumber'],
        valueGetter: (params: any) => params.row.customer?.vatIdNumber || '--',
      },
      {
        field: 'companyRegistrationNumber',
        headerName: 'Company Registration Number',
        minWidth: 250,
        sortPath: ['customer', 'companyRegistrationNumber'],
        valueGetter: (params: any) => params.row.customer?.companyRegistrationNumber || '--',
      },
      {
        field: 'createdBy',
        renderHeader: () => (
          <Box sx={{ whiteSpace: 'normal', lineHeight: 'normal' }}>
            <strong>Created By</strong>
            <br />
            (Company Owner)
          </Box>
        ),
        minWidth: 250,
        sortPath: ['customer', 'createdBy'],
        valueGetter: (params: any) => params.row.customer?.createdBy || '--',
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        minWidth: 200,
        sortPath: ['customer', 'createdAt'],
        valueGetter: (params: any) => params.row.customer?.createdAt,
        valueFormatter: (params: any) =>
          params.value ? new Date(params.value).toLocaleString('en-GB') : '--',
      },
    ],
    [],
  )

  return columns
}

export default useGetExportCustomersColumns
